import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, } from '@angular/core';
// import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import {
  Transaction,
  TransactionProgress,
  TransactionRefundOption,
  TransactionsStore,
  TransactionState,
  TransactionVendorReference,
} from '@fry/payments/lib';
import { TransactionComponentEvent } from './transaction.component.interfaces';

/**
 * Refund handling component
 *
 */
@Component({
    selector: 'eas-refund',
    templateUrl: './refund.component.html',
    standalone: false
})
export class RefundComponent implements OnInit, OnDestroy {

    //
    // Properties
    //

    @Input() transaction: Transaction;
    @Output() notification = new EventEmitter<TransactionComponentEvent>();

    public payment: Transaction;
    public error: Error;

    constructor(
        public dialogRef: MatDialogRef<RefundComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private store: TransactionsStore
    ) {
        if (data && data['transaction']) {
            this.transaction = data['transaction'];
        }
     }

    ngOnInit() {
        forkJoin([
            this.store.getWithDependencies(this.transaction.id),
            this.store.getWithDependencies(this.transaction.relatedTransaction)
        ]).subscribe(
            ([refund, payment]) => {
                this.transaction = refund;

                // const refundOption = refund.refundOption
                //                      ? refund.refundOption
                //                      : refund.refundOptions.find(o => o ? o.default : false);

                // this.form = new FormGroup({
                //     amount: new FormControl(undefined, [
                //                                 Validators.max(payment.amount),
                //                                 Validators.min(0)]
                //                            ),
                //     option: new FormControl(refundOption,
                //                             Validators.required)
                // });

                this.payment = payment;
                // this.updateRefundAmountForOption(payment, undefined);
            }
        );
    }

    ngOnDestroy() { }

    //
    // Template helpers
    //

    public isReady(): boolean {
        return this.transaction !== undefined && this.payment !== undefined;
    }

    public hasError(): boolean {
        return this.error !== undefined;
    }

    public isComplete(): boolean {
        return this.transaction.state === TransactionState.Completed;
    }

    public canChangeRefundAmount(): boolean {
        return false;
    }

    public compareRefundOption(a: TransactionRefundOption,
                               b: TransactionRefundOption): boolean {
        return a && b
               ? a.title === b.title
               : a === b;
    }

    //
    // Actions
    //

    onCancel() {
        this.dialogRef.close();
    }

    onRefund(reference?: TransactionVendorReference) {
        // Submit transaction to backend
        const transaction$ = this.store.getWithDependencies(this.transaction.id);
        const capture$ = this.store.capture(this.transaction, reference);
        capture$.pipe(
            switchMap(progress => {
                return transaction$.pipe(
                    map(transaction => [progress, transaction])
                );
            })
        ).subscribe(result => {
            const transaction = result[1] as Transaction;
            const progress = result[0] as TransactionProgress;
            this.transaction = transaction;

            switch (this.transaction.state) {
                case TransactionState.Completed: {
                    const event: TransactionComponentEvent = {
                        type: 'capture_success',
                        payload: { 'transaction': transaction }
                    };
                    this.notification.emit(event);
                    this.dialogRef.close(event);
                    break;
                }
                case TransactionState.Failed: {
                    const error: Error = new Error(progress.vendor['error']);
                    const event: TransactionComponentEvent = {
                        type: 'capture_error',
                        payload: { 'transaction': transaction }
                    };
                    this.onError(error, event);
                    this.dialogRef.close(event);
                    break;
                }
                case TransactionState.Actioned:
                case TransactionState.Pending:
                    // These cases are not handled at the moment
                    break;
            }
        },
        error => {
            this.onError(new Error(error));
        });
    }

    onError(error: Error, event?: TransactionComponentEvent) {
        if (error === undefined) {
            this.error = undefined;
            return;
        }

        this.error = error;
        const e: TransactionComponentEvent = event !== undefined
                 ? event
                 : { type: 'error', payload: { 'error': error } };
        this.notification.emit(e);
    }

}
